import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Commands, Info, Results, Search } from '@local/client-contracts';
import { ManualPromise } from '@local/common';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { HighlightStyle } from '@shared/pipes';
import { LogService } from '@shared/services';
import { SessionService } from '@shared/services/session.service';
import { Logger } from '@unleash-tech/js-logger';
import { HubService } from 'src/app/bar/services/hub.service';
import { PeopleService } from '../../../preview/people-preview/services/people.service';
import { SearchResults } from '../../models/results-types';
import { LinksService } from '@shared/services/links.service';
import { combineLatest } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'result-rich-text-person',
  templateUrl: './result-rich-text-person.component.html',
  styleUrls: ['./result-rich-text-person.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultRichTextPersonComponent implements OnInit, AfterViewInit {
  private afterViewInitPromise: ManualPromise<void> = new ManualPromise();
  private resourcePerson: Search.ResultResourceItem;
  private peopleLinkId: string;
  private user: Info;
  private logger: Logger;
  isMe: boolean;
  highlightStyle: HighlightStyle = 'default';

  @Input() model: Results.RichTextPerson;
  @Input() highlights: Array<string>;

  @Output() invoke = new EventEmitter<Commands.Command>();

  constructor(
    private hubService: HubService,
    private linksService: LinksService,
    private peopleService: PeopleService,
    private logService: LogService,
    private session: SessionService,
    private cdr: ChangeDetectorRef
  ) {
    combineLatest([this.session.current$, this.linksService.peopleLinkId$])
      .pipe(untilDestroyed(this))
      .subscribe(async ([current, peopleLinkId]) => {
        if (!current) {
          return;
        }
        this.user = current.user;
        this.peopleLinkId = peopleLinkId;
        await this.initMe();
      });
  }

  ngOnInit(): void {
    this.logger = this.logService.scope('ResultRichTextPerson');
  }


  ngAfterViewInit(): void {
    this.afterViewInitPromise.resolve();
  }

  private async initMe() {
    await this.afterViewInitPromise;
    this.isMe = this.model.email === this.user.email;
    this.cdr.markForCheck();
  }

  openPreview() {
    if (!this.model.email || !this.peopleLinkId) {
      this.onClickCommand();
      return;
    }
    this.peopleService.getPerson(null, this.model.email).then((val) => {
      val.pipe(untilDestroyed(this)).subscribe(
        (person) => {
          this.resourcePerson = person?.details?.source;
          this.invoke.emit(this.previewCommand());
        },
        (err) => {
          this.logger.error('failed to get person via email', err);
          this.onClickCommand();
        }
      );
    });
  }

  private previewCommand(): Commands.Preview<SearchResults> {
    return {
      type: 'preview',
      previewable: true,
      state: 'popup',
      model: {
        ...this.resourcePerson,
        action: { type: 'people', click: { primary: { type: 'preview' } } },
      } as Search.ResultResourceItem,
    } as Commands.Preview<SearchResults>;
  }

  private onClickCommand() {
    if (!this.model.onClick) return;
    this.invoke.emit(this.model.onClick);
  }
}
